import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from "@components/common";

/**
 * InvoiceDisclaimer component displays an invoice disclaimer section with an optional textarea for editing.
 *
 * @param {Object} props - Component props.
 * @param {string} props.disclaimer - The disclaimer text to display or edit.
 * @param {boolean} props.showTextArea - Whether to show the textarea for editing the disclaimer.
 * @param {function} props.handleInvoiceChange - Callback function to handle changes in the textarea.
 * @returns {JSX.Element|null} The rendered disclaimer section or null if not applicable.
 */
const InvoiceDisclaimer = ({ disclaimer, showTextArea, handleInvoiceChange }) => {
  const { lang } = global;

  return (
	<div className={`row ${!disclaimer && !showTextArea ? "hidden" : ""}`}>
      <div className={`col-xs-12 ${!showTextArea ? "form-group" : "text-right"}`}>
        <label htmlFor="invoice-disclaimer">
          {lang.t("Invoice")} {lang.t("Disclaimer")}
          <Tooltip
            content={lang.t(
              "This information will be shown to clients so they understand payment conditions",
            )}
          >
            <i className="hidden-xs rkf rkf-question-solid tooltip-icon" />
          </Tooltip>
        </label>
		{ showTextArea && (
			<textarea
				id="invoice-disclaimer"
				name="invoice-disclaimer"
				className="form-control"
				rows={3}
				value={disclaimer}
				placeholder={lang.t("e_g_ Net 15 for all invoices")}
				onChange={handleInvoiceChange("invoiceDisclaimer")}
			/>
		)}
        <div className="visible-print-block">{disclaimer}</div>
      </div>
    </div>
  );
};

InvoiceDisclaimer.propTypes = {
  disclaimer: PropTypes.string,
  showTextArea: PropTypes.bool,
  handleInvoiceChange: PropTypes.func
};

InvoiceDisclaimer.defaultProps = {
  disclaimer: '',
  showTextArea: false,
  handleInvoiceChange: () => {}
};

export default InvoiceDisclaimer;
